<template>
    <div id="UserCmntsList">
        <b-container>
            <h5 class="text-center">
                {{ $t('AUTHOR') }} : {{ userName }}. {{ $t('CMNTS') }}.
                <span v-if="published">{{$t('PUBLISHED')}}</span>
                <span v-else>{{$t('UNPUBLISHED')}}</span>
            </h5>
                <b-table
                        ref="itemList"
                        selectable
                        :items="items"
                        :fields="fields"
                        :key="myKey"
                        striped
                        head-row-variant="info"

                >
                    <template #cell(cmntName)="data">
                        <b-button variant="outline-info" @click="goCmnt(data.item)">{{ data.item.cmntName }}</b-button>
                    </template>
                    <template #cell(userNameForCmnt)="data">
                        {{ data.item.userNameForCmnt }}
                    </template>
                    <template #cell(itemNameForCmnt)="data">
                        <b-button variant="outline-info" @click="goItem(data.item)">{{ data.item.itemNameForCmnt }}</b-button>
                    </template>
                </b-table>

            <div class="modalConf">
                <b-modal id="modalConf">
                    <div class="d-block text-center">
                        <h4>{{this.$t('SURE')}}</h4>
                    </div>
                    <template v-slot:modal-footer="{ cancel }">
                        <b-button variant="success" @click="cancel()">Нет</b-button>
                        <b-button variant="danger" @click="canAct()">Да</b-button>
                    </template>
                </b-modal>
            </div>

            <div v-html="mess"> </div>

        </b-container>

        <b-container fluid class = "footer text-center">

            <center>
                <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                    <a v-b-popover.hover.top="this.$t('SHOW')" title="" class="shBt">
                        <b-form-radio value="Trip">
                            <font-awesome-icon icon="eye" size="lg" :style="{ color: 'white' }" />
                        </b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('PUBLISH')" title="" v-if="!published && (author || admin)">
                        <b-form-radio value="publishCmnt">
                            <font-awesome-icon icon="users" size="lg" :style="{ color: 'white' }" />
                        </b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('UNPUBLISH')" title="" v-if="published && (author || admin)">
                        <b-form-radio value="unPublishTrip">
                            <font-awesome-icon icon="users-slash" size="lg" :style="{ color: 'white' }" />
                        </b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('DELETE')" title="" v-if="author || admin" class="shBt">
                        <b-form-radio value="deleteTrip">
                            <font-awesome-icon icon="trash-alt" size="lg" :style="{ color: 'white' }" />
                        </b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('BLOCK')" title="" v-if="admin">
                        <b-form-radio value="blockTrip">
                            <font-awesome-icon icon="lock" size="lg" :style="{ color: 'white' }" />
                        </b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('UNBLOCK')" title="" v-if="admin">
                        <b-form-radio value="unBlockTrip">
                            <font-awesome-icon icon="lock-open" size="lg" :style="{ color: 'white' }" />
                        </b-form-radio>
                    </a>
                </b-form-radio-group>
            </center>

        </b-container>

    </div>

</template>

<script>
import { BContainer, BTable, BModal, BButton, BFormRadio, BFormRadioGroup } from 'bootstrap-vue';

export default {
  name: 'UserCmntsList',
  components: {
    BContainer, BTable, BModal, BButton, BFormRadio, BFormRadioGroup
  },
  data: function() {
    return {
        fields: [
          {
            key: 'cmntName',
            label: this.$t('DATE_TIME'),
            sortable: true
          },
          {
            key: 'userNameForCmnt',
            label: this.$t('AUTHOR'),
            sortable: true
          },
          {
            key: 'itemNameForCmnt',
            label: this.$t('RES'),
            sortable: true
          }
        ],
        myKey: 0,
        items: [{}],
        tblName: '',
        userName: '',
        curUserName: '',
        tripName: '',
        listLoc: this.$i18n.locale,
        item: {},
        selected: 'Trip',
        mess: "",
        //key: 0,
        curLang: '',
        published: true,
        left: '',
        action: ''
    }
  },
  mounted() {
    this.curUserName = this.$store.state.curUserName;
    if(!this.curUserName) this.$showErr(this.$t('TMOUT'), 401);
    this.userName = this.$rmEncHyp(this.$route.params.userName);
    if(this.curUserName && (this.curUserName === this.userName || this.curUserName === 'admin') ) {
        this.published = this.$route.query.published === 'false' ? false: true;
        this.blocked = this.$route.query.blocked === 'true' ? true: false;
    }
    else {
        this.published = true;
        this.blocked = false;
    }
    this.fields[0].label = this.$t('DATE_TIME');
    this.getList();
  },
  methods: {
    async getList() {
        try {
            const response = await this.$http.get('/getUserCmnts', {
                params: {
                    userName: this.userName,
                    published: this.published,
                    blocked: this.blocked
                }
            });
            this.items = response.data;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    reloadList() {
        this.selected='Trip';
        this.action='';
        this.getList();
        this.myKey++;
    },
    goCmnt(item) {
        this.item = item;
        this.tripName = item.cmntName;
        if(this.selected==='Trip') {
            this.$router.push({
               path: '/Tour/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.userName)
            })
        }
        if(this.selected==='publishCmnt') {
            this.canAct();
        }
        else this.$bvModal.show('modalConf');
    },
    goItem(item) {
        if(item.itemTypeForCmnt=='trip')
            this.$router.push({
               path: '/Tour/'+this.$addEncHyp(item.itemNameForCmnt)+'/'+this.$addEncHyp(item.userNameForCmnt),
            })
        else if(item.itemTypeForCmnt=='place')
            this.$router.push({
               path: '/Place/'+this.$addEncHyp(item.itemNameForCmnt)+'/'+this.$addEncHyp(item.userNameForCmnt)
            })
        else if(item.itemTypeForCmnt=='outing')
            this.$router.push({
               path: '/Outing/'+this.$addEncHyp(item.itemNameForCmnt)+'/'+this.$addEncHyp(item.userNameForCmnt)
            })
    },
    async canAct() {
        this.$bvModal.hide('modalConf');
        let itemTypeForCmnt = this.item.itemTypeForCmnt=='trip' ? 'tt' : this.item.itemTypeForCmnt=='place' ? 'tp' : 'to';
        try {
            const response = await this.$http.get('/'+this.selected, {
                params: {
                    userName: this.userName,
                    tripName: this.tripName,
                    itemName: this.tripName,
                    userNameForCmnt: this.item.userNameForCmnt,
                    itemNameForCmnt: this.item.itemNameForCmnt,
                    itemTypeForCmnt: itemTypeForCmnt
                }
            });
            this.$showMsg(response.data);
            this.reloadList();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async deleteTrip() {
        this.$bvModal.hide('modalConf');
        try {
            await this.$http.get('/deleteTrip', {
                params: {
                    userName: this.userName,
                    tripName: this.tripName
                }
            });
            this.$showMsg(this.$t('DONE'));
            this.getList();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    }
  },
  watch: {
      curLang: function() {
        //alert(this.$i18n.locale);
      }
  },
  computed: {
    rows() {
        return this.listLength;
    },
    author() { return this.userName === this.curUserName },
    admin() { return this.curUserName === 'admin' }
  }
}

</script>

<style>
</style>
